import timePickerDarkRule from '../../../common/algorithms/time-picker-dark-rule';

const dark = (params) => timePickerDarkRule(params, { step: 2, darkShade: '100' });

export default dark;
